// extracted by mini-css-extract-plugin
module.exports = {"Board":"Board_Board__Wpjri"};